export default {
    DIVERSE_SALUTATION_KEY: 'salutationDiverse',
    NONE_SALUTATION_KEY: 'salutationNone'
}
